import Vue from 'vue';
import VueRouter from 'vue-router';
import ReservationCalendar from '../pages/ReservationCalendar.vue';
import EntryForm from "@/pages/EntryForm.vue";
Vue.use(VueRouter);
var routes = [
    {
        path: '/calendar/:corporateID',
        name: 'cal',
        component: ReservationCalendar
    },
    {
        path: '/entry',
        name: 'EntryForm',
        component: EntryForm,
        props: true,
    },
];
var router = new VueRouter({
    mode: 'history',
    routes: routes
});
export default router;
